module.exports = __webpack_public_path__ + "media/images/march8/march8-template-ge-abd34fe894b8026a59a6fec373ed2713.png";